// builder-components.ts
import { Builder } from '@builder.io/react';

import { AepBannerOneTextLine } from '../../organisms/aep-banner/aep-banner-one-text-line';

Builder.registerComponent(AepBannerOneTextLine, {
  name: 'OneTextLineBanner',
  inputs: [{ name: 'message', type: 'text' }],
  noWrap: false,
});
